<template>
  <section class="page-container">
    <template v-if="!isReferralRequest">
      <h1>New Refer Case Support Ticket</h1>
      <span>Based on the information previously provided, a refer case had to be made to quote. </span>
      <div class="abs-top-right">
        <v-button
          v-if="isFina"
          icon="user-tie"
          gray
          @click="handlerSelect(2)">{{btn_refer_text}}</v-button>
        <v-button
          v-else
          icon="user-circle"
          gray
          @click="handlerSelect(1)">{{btn_text}}</v-button>
        <v-button @click="() => $router.back()">Previous</v-button>
        <v-button
          type="primary"
          @click="handlerCreate">Create</v-button>
      </div>
    </template>
    <template v-else>
      <h1>Convert to Refer Case Ticket</h1>
      <span>Based on the information previously provided, a refer case had to be made to quote. </span>
      <div class="abs-top-right">
        <v-button @click="handlerBack">Back</v-button>
        <v-button
          type="primary"
          @click="handlerConvert">Convert</v-button>
      </div>
    </template>
    <template v-if="isFina">
      <div class="p-class">
        <span class="bold">You are assisting a 3rd party to pre-fill information in
          <span class="width-20">
            <v-select
              v-model="cust_typ"
              :disabled="disabledType||isMotorTrade"
              :list="userTypeOptions"></v-select></span>
        </span>
        <span class="bold mg-l-10">capacity</span>
      </div>
    </template>
    <housemaid-refer v-if="productId == 12" />
    <working-refer v-else-if="productId == 13" />
    <travel-refer v-else-if="productId == 14" />
    <decoration-refer v-else-if="productId == 15" />
    <student-refer v-else-if="productId == 16" />
    <homefire-refer v-else-if="productId == 17" />
    <personal-refer v-else-if="productId == 18" />
    <fire-refer v-else-if="productId == 20" />
    <pet-refer v-else-if="productId == 22" />
    <template v-else>
      <div v-if="quoteForm.class_id!=15">
        <div class="table">
          <div class="tr th">
            <span>Item</span>
            <span>Information</span>
          </div>
          <div class="tr">
            <span>Car Type</span>
            <span>{{ getOptionName('classOptions', quoteForm.class_id) }}</span>
          </div>
        </div>
        <template v-if="quoteForm.class_id === 14">
          <h2>Insured Motorcycle</h2>
          <div class="table">
            <div class="tr th">
              <span>Item</span>
              <span>Information</span>
            </div>
            <div class="tr">
              <span>Car Use</span>
              <span>{{ getOptionName('classOptions', quoteForm.class_id) }}</span>
            </div>
            <div class="tr">
              <span>Make</span>
              <span>{{ getAllOptionName('brand', quoteForm.brand_id ) }}</span>
            </div>
            <div class="tr">
              <span>Body Type</span>
              <span>{{ getAllOptionName('typ_of_bdy', quoteForm.typ_of_bdy_id ) }}</span>
            </div>
            <div class="tr">
              <span>Cylinder Capacity (Input "0" for EV)</span>
              <span>{{ quoteForm.engn_cpcty }} cc</span>
            </div>
            <div class="tr">
              <span>Year of Manufacture</span>
              <span>{{ getAllOptionName('rgtn_yr', quoteForm.rgtn_yr ) }}</span>
            </div>
            <div class="tr">
              <span>NCD</span>
              <span>{{ getAllOptionName('ncd', quoteForm.ncd_pct ) }}</span>
            </div>
          </div>
        </template>
        <template v-else-if="quoteForm.class_id === 11">
          <h2>Insured Private Car </h2>
          <div class="table">
            <div class="tr th">
              <span>Item</span>
              <span>Information</span>
            </div>
            <div class="tr">
              <span>Make</span>
              <span>{{ getAllOptionName11('brand', quoteForm.brand_id ) }}</span>
            </div>
            <div class="tr">
              <span>Model</span>
              <span>{{ getOptionName('carModelOptions', quoteForm.model_id ) }}</span>
            </div>
            <div class="tr">
              <span>Body Type</span>
              <span>{{ getAllOptionName11('typ_of_bdy', quoteForm.typ_of_bdy_id ) }}</span>
            </div>
            <div
              v-if="!quoteForm.is_electric_car"
              class="tr">
              <span>Cylinder Capacity</span>
              <span>{{ quoteForm.engn_cpcty }} cc</span>
            </div>
            <div class="tr">
              <span>Year of Manufacture</span>
              <span>{{ getAllOptionName11('rgtn_yr', quoteForm.rgtn_yr ) }}</span>
            </div>
            <div class="tr">
              <span>NCD</span>
              <span>{{ getAllOptionName11('ncd', quoteForm.ncd_pct ) }}</span>
            </div>
          </div>
        </template>
        <template v-else-if="quoteForm.class_id === 12">
          <h2>Insured Commercial Car </h2>
          <div class="table">
            <div class="tr th">
              <span>Item</span>
              <span>Information</span>
            </div>
            <div class="tr">
              <span>Vehicle Type</span>
              <span>{{ getAllOptionName12('tonnage', quoteForm.tonnage) }}</span>
            </div>
            <div class="tr">
              <span>Make</span>
              <span>{{ getAllOptionName12('brand', quoteForm.brand_id ) }}</span>
            </div>
            <!-- <div class="tr">
              <span>Body Type</span>
              <span>{{ getAllOptionName12('typ_of_bdy', quoteForm.typ_of_bdy_id ) }}</span>
            </div> -->
            <!-- <div class="tr">
              <span>Permitted Gross Combined Weight</span>
              <span>{{ quoteForm.tonnage }} cc</span>
            </div> -->
            <div class="tr">
              <span>Year of Manufacture</span>
              <span>{{ getAllOptionName12('rgtn_yr', quoteForm.rgtn_yr ) }}</span>
            </div>
            <div class="tr">
              <span>NCD</span>
              <span>{{ getAllOptionName12('ncd', quoteForm.ncd_pct ) }}</span>
            </div>
          </div>
        </template>
        <template v-else-if="quoteForm.class_id===13">
          <div class="table">
            <div class="tr th">
              <span>Item</span>
              <span>Information</span>
            </div>
            <div class="tr">
              <span>User Type</span>
              <span>{{ getOptionName('userTypeOptions', quoteForm.cust_typ) }}</span>
            </div>
            <div class="tr">
              <span>Type of insurance</span>
              <span>{{ getAllOptionName13('type_of_ins', quoteForm.type_of_ins) }}</span>
            </div>
            <div
              v-if="quoteForm.type_of_ins==2"
              class="tr">
              <span>Number of Named Driver(s)</span>
              <span>{{ getOptionName('numberFourOptions', quoteForm.no_of_nm_drvr) }}</span>
            </div>
            <div class="tr">
              <span>No Claims in the past 3 years?</span>
              <span>{{ getOptionName('yesNoOptions', quoteForm.no_claim_3_year) }}</span>
            </div>
          </div>
        </template>
        <template v-if="quoteForm.class_id!=13">
          <h2>Coverage Detail</h2>
          <div class="table">
            <div class="tr th">
              <span>Item</span>
              <span>Information</span>
            </div>
            <div class="tr">
              <span>Coverage</span>
              <span>{{ getOptionName('allCoverTypeOptions', quoteForm.trm_of_cvr) }}</span>
            </div>
            <div
              v-if="quoteForm.class_id !== 14 && quoteForm.trm_of_cvr != 1"
              class="tr">
              <span>Vehicle Market Value (Sum Insured)</span>
              <span>{{ quoteForm.isrd_vl }}</span>
            </div>
            <template v-if="quoteForm.class_id == 11">
              <div class="tr">
                <span v-if="quoteForm.enough_age_ind==1">Are all the driver(s) 25-65 years old?</span>
                <span v-else>Are all the driver(s) 31-60 years old?</span>
                <span v-if="quoteForm.enough_age_ind==1">{{ getOptionName('yesNoOptions', quoteForm.enough_age_ind) }}</span>
                <span v-else>{{ getOptionName('yesNoOptionsDirver', quoteForm.enough_age_ind) }}</span>
              </div>
            </template>
            <template v-if="quoteForm.class_id == 12">
              <div class="tr">
                <span>Will the vehicle be used by third party for carrying goods for reward?</span>
                <span>
                  {{ getOptionName('yesNoOptions', quoteForm.use_carrying_profit_ind) }}
                </span>
              </div>
            </template>
            <div
              v-if="quoteForm.class_id == 11"
              class="tr">
              <span v-if="quoteForm.class_id == 11">Does all the named driver(s) have over 2 years of a proper private vehicle driving license?</span>
              <span v-else>Does all the named driver(s) have over 2 years of a proper commercial vehicle driving license?</span>
              <span>
                {{ getOptionName('yesNoOptions', quoteForm.enough_exp_ind) }}
              </span>
            </div>
            <div
              v-if="quoteForm.no_acci_nor_deduct==0&&quoteForm.class_id!=12"
              class="tr">
              <span>Are all the driver(s) has not been involved in a motor accident nor deduction of driving offence over 5 points in the past three years?</span>
              <span >{{ getOptionName('yesNoOptions', quoteForm.no_acci_nor_deduct) }}</span>
            </div>
            <div
              v-if="quoteForm.no_acci_nor_deduct!=0&&quoteForm.class_id!=12"
              class="tr">
              <span>Are all the driver(s) has not been involved in a motor accident in the past 3 years?</span>
              <span >{{ getOptionName('acciOptions', quoteForm.no_dr_acci_ind) }}</span>
            </div>
            <div
              v-if="quoteForm.no_acci_nor_deduct!=0&&quoteForm.class_id!=12"
              class="tr">
              <span>Are all the driver(s) has not been deducted driving offence points in the past 3 years? </span>
              <span >{{ getOptionName('deductOptions', quoteForm.no_dr_deduct_ind) }}</span>
            </div>
            <div v-if="isFormDriver">
              <div
                v-for="(item,index) in quoteForm.nm_drvr_list"
                :key="index">
                <div class="tr th">
                  <span>{{'Driver'+(index+1)}}</span>
                </div>
                <div
                  v-if="quoteForm.class_id==14"
                  class="tr">
                  <span>Named driver age</span>
                  <span>
                    {{item.nm_drvr_age}}
                  </span>
                </div>
                <div
                  v-if="quoteForm.class_id==12"
                  class="tr"
                >
                  <span>Named driver age</span>
                  <span>{{item.nm_drvr_age?item.nm_drvr_age:getAllOptionName12('drvr_age',item.nm_drvr_age)}}</span>
                </div>
                <div
                  v-if="quoteForm.class_id==11"
                  class="tr"
                >
                  <span>Named driver age</span>
                  <!--              <span>{{getAllOptionName11('drvr_age',item.nm_drvr_age)}}</span>-->
                  <span>{{item.nm_drvr_age?item.nm_drvr_age:getAllOptionName11('drvr_age',item.nm_drvr_age)}}</span>
                </div>
                <div
                  v-if="quoteForm.class_id==14"
                  class="tr">
                  <span>Driving licence of Named Driver</span>
                  <span>
                    {{ getAllOptionName('dr_lic_of_own', item.nm_drvr_exp) }}
                  </span>
                </div>
                <div
                  v-if="quoteForm.class_id==11"
                  class="tr">
                  <span>Driving license</span>
                  <span>{{getAllOptionName11('drvr_exp',item.nm_drvr_exp)}}</span>
                </div>
                <div
                  v-if="quoteForm.class_id==12"
                  class="tr">
                  <span>Driving license</span>
                  <span>{{getAllOptionName12('drvr_exp',item.nm_drvr_exp)}}</span>
                </div>
                <div
                  v-if="quoteForm.class_id!=12"
                  class="tr">
                  <span>Number of accident in last 3 years</span>
                  <span>
                    {{ getAllOptionName('accident_num', item.nm_drvr_acc) }}
                  </span>
                </div>
                <div
                  class="tr">
                  <span>Number of driving offence point in last 3 years</span>
                  <span>
                    {{ getAllOptionName('off_points', item.nm_drvr_pt) }}
                  </span>
                </div>
                <div
                  class="tr">
                  <span>Driver Occupation</span>
                  <span>
                    {{ getAllOptionName('occupation', item.nm_drvr_occ_id) }}
                  </span>
                </div>
              </div>
            </div>
            <div
              v-if="quoteForm.class_id==11&&extraBenefitSelect.length>0"
              class="tr">
              <span>Extra Benefits</span>
              <span>
                <span
                  v-for="(item,index) in extraBenefitSelect"
                  :key="'extra'+index">{{item.name}}<br></span>
              </span>
            </div>
          </div>

          <template v-if="benefitsList.length > 0">
            <h2>More Benefits</h2>
            <div class="benefits-list">
              <span
                v-for="(item, index) in benefitsList"
                :key="index">
                {{ item }}
              </span>
            </div>
          </template>
        </template>
      </div>
      <hzmb-underwriting-refer v-else></hzmb-underwriting-refer>
    </template>

    <attach-customer
      ref="attachCustomer"
      :is-motor-trade="isMotorTrade"
      :is-personal="quoteForm.class_id==15"
      :motor-cust-type="quoteForm.cust_typ"
      :customer-type="select_type"
    ></attach-customer>
    <send-email-sms
      ref="send-email-sms"
      :form="customer_profile"
      :initContent="initContent"
      :emailListTitle="emailListTitle"
      :emailTitle="emailTitle"
      :updateContent="true"
      @skip="handlerSkip"
      @send="handlerSend" />
  </section>
</template>
<script>
// import BaseInfo from '../components/base-info'
// import DriversInfo from '../components/drivers-info'
// import DriversInfoForm from '../components/drivers-info-form'
import {mapState} from 'vuex'
import MixinOptions from '@/mixins/options'
import {addReferral} from '@/api/refer'
import HousemaidRefer from './modules/housemaid/underwriting-refer'
import WorkingRefer from './modules/working/underwriting-refer'
import TravelRefer from './modules/travel/underwriting-refer'
import StudentRefer from './modules/student/underwriting-refer'
import DecorationRefer from './modules/decoration/underwriting-refer'
import HomefireRefer from './modules/homefire/underwriting-refer'
import fireRefer from './modules/homefire/fire-underwirting-refer'
import PersonalRefer from './modules/personal/underwriting-refer'
import PetRefer from './modules/pet/underwriting-refer'
import attachCustomer from '@/views/quoting/dialogs/attachCustomer'
import {convertReferralRequestRefer} from '@/api/request'
import SendEmailSms from '@/views/components/dialogs/send-email-sms'
import {getAccountDetail, getSmsTemplate} from '@/api/account'
import MixinFina from '@/mixins/fina'
import {onlyCompanyProductId, onlyPersonalProductId} from '@/utils/product'
import HzmbUnderwritingRefer from '@/views/quoting/modules/hzmb/underwriting-refer'

export default {
  name: 'Refer',
  components: {
    HzmbUnderwritingRefer,
    // BaseInfo,
    // DriversInfo,
    // DriversInfoForm
    HousemaidRefer,
    WorkingRefer,
    TravelRefer,
    StudentRefer,
    DecorationRefer,
    HomefireRefer,
    fireRefer,
    attachCustomer,
    PersonalRefer,
    SendEmailSms,
    PetRefer
  },
  mixins: [MixinOptions,MixinFina],
  props: {
    isReferralRequest: {
      type: Boolean,
      default: false
    },
    referralRequestId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      // confirmNext: false,
      select_type:1,
      detailData:{},
      initContent:'',
      emailTitle: '',
      emailListTitle: '',
      account_id:'',
      cust_typ:'',
      onlyPersonal:[...onlyPersonalProductId],
      onlyCompany:[...onlyCompanyProductId],
    }
  },
  computed: {
    ...mapState('common', ['productId']),
    ...mapState('quote', ['quoteForm', 'carModelOptions']),
    ...mapState('account', ['customerId', 'selectCustomerData','selectReferCustomerData','referCustomerId']),
    ...mapState('account', ['customerId']),
    benefitsList() {
      let benefitsData = []
      if(this.quoteForm.benefits) {
        benefitsData = JSON.parse(JSON.stringify(this.quoteForm.benefits))
      }
      const getName = this[`getAllOptionName${this.quoteForm.class_id}`]
      // benefitsData.map(item => {
      //   return item
      // })
      // return benefitsData
      const result = []
      benefitsData.forEach(item => {
        if(getName)
          result.push(getName('benefits', item))
      })
      return result||[]
    },
    extraBenefitSelect(){
      let {extra_benefits_content={}} = this.formData||{}
      let arr =[]
      if(extra_benefits_content){
        arr = Object.entries(extra_benefits_content).map(item=>item[1])
      }
      return arr||[]
    },
    isFormDriver(){
      // let { no_dr_acci_ind, no_dr_deduct_ind,enough_age_ind,enough_exp_ind,class_id} = this.quoteForm||{}
      // return no_dr_acci_ind&&no_dr_deduct_ind&&enough_age_ind&&enough_exp_ind&&(class_id==11||class_id==12)
      return this.quoteForm.nm_drvr_list && this.quoteForm.nm_drvr_list.length > 0
    },
    customer_profile() {
      let {customer_profile = {}} = this.detailData || {}
      return customer_profile
    },
    isFina() {
      let path = this.$route.path
      return path.includes('/fina/')
    },
    classId() {
      let {class_id} = this.quoteForm || {}
      return class_id || 11
    },
    disabledType() {
      const productId = Number(this.productId)
      if (this.customerId || this.classId == 12) return true
      if (this.onlyPersonal.includes(productId)) return true
      if (this.onlyCompany.includes(productId)) return true
      return false
    },
    isMotorTrade(){
      let {class_id} = this.quoteForm||{}
      return class_id == 13
    }
  },
  watch: {
    classId: {
      immediate: true,
      handler(val) {
        if (val == 12) {
          let {cust_typ} = this.quoteForm || {}
          this.cust_typ = cust_typ
        }
      }
    }
  },
  mounted() {
    if(this.isFina){
      if(this.isMotorTrade){
        let {cust_typ} = this.quoteForm||{}
        this.cust_typ = cust_typ
      }else {
        if(this.onlyPersonal.includes(Number(this.productId))) {
          this.cust_typ = 1
        }
        else if(this.onlyCompany.includes(Number(this.productId))) {
          this.cust_typ = 2
        }
        else this.cust_typ = 1
      }
    }
  },
  methods: {
    handlerSelect(type){
      this.select_type = type
      this.$refs.attachCustomer.showAttachCustomer()
    },
    handlerSend(content){
      let params = {}
      this.quoteForm.is_send = 1
      this.quoteForm.content = content
      delete this.quoteForm.id
      this.$refs['send-email-sms'].changeDialog()
      this.network().addReferral(this.quoteForm)
    },
    handlerSkip(){
      this.quoteForm.is_send = 0
      delete this.quoteForm.id
      this.$refs['send-email-sms'].changeDialog()
      this.network().addReferral(this.quoteForm)
    },
    handlerContent(){
      let {customer_profile={}} = this.detailData||{}
      let {language} = customer_profile
      this.network().getSmsTemplate({language})
    },
    getExp(nm_drvr_exp){
      if(nm_drvr_exp)
        return this.getAllOptionName('drvr_exp',nm_drvr_exp)
      else{
        return this.getAllOptionName('drvr_exp',this.quick_quote_detail.dr_lic_of_own)
      }
    },
    handlerConvert() {
      this.network().convertReferralRequestRefer()
    },
    handlerBack() {
      this.$emit('back')
    },
    handlerCreate() {
      if(!this.isFina&&!this.customerId){
        this.select_type = 1
        this.handlerSelect(1)
        return
      }
      if(this.isFina&&!this.referCustomerId){
        this.select_type = 2
        this.handlerSelect(2)
        return
      }
      if(this.isFina){
        this.quoteForm.referrer_id=this.referCustomerId
        delete this.quoteForm.customer_id
        this.account_id = this.selectReferCustomerData.id
      }else
      {
        this.quoteForm.customer_id = this.customerId
        delete this.quoteForm.referrer_id
        this.account_id = this.customerId
      }
      if(!this.isFina)
      {
        // this.network().getAccountDetail()
        delete this.quoteForm.id
        this.network().addReferral(this.quoteForm)
      }
      else
        this.network().addReferral(this.quoteForm)
    },
    network() {
      return {
        addReferral: async (params) => {
          if(this.isMotorTrade){
            params.trm_of_cvr =1
          }
          const { query } = this.$route
          const { from } = query
          let resultParams = {
            ...params,
            product_id: this.productId,
            merchant_platform:this.isFina?2:1,
          }
          if(from == 'part') {
            // resultParams.part_of_under_cond = 1
            resultParams.underwriting_confirm = 2
          }
          if(this.isFina){
            resultParams.cust_typ = this.cust_typ
          }
          let { data } = await addReferral(resultParams)
          this.$router.push({
            path: '/tickets/detail',
            query: {
              ticket_id: data.ticket_id
            }
          })
        },
        convertReferralRequestRefer: async () => {
          const { data } = await convertReferralRequestRefer({
            ...this.quoteForm,
            referral_request_id: this.referralRequestId,
            merchant_platform:this.isFina?2:1
          })
          this.$emit('success')
        },
        getAccountDetail: async () => {
          const {data} = await getAccountDetail({
            customer_id: this.account_id
          })
          this.detailData = data
          this.handlerContent()
          this.$refs['send-email-sms'].changeDialog()
        },
        getSmsTemplate: async (params) => {
          const {data} = await getSmsTemplate(params)
          let {refer_case, refer_case_list_title, refer_case_title} = data
          this.initContent =  refer_case
          this.emailListTitle = refer_case_list_title
          this.emailTitle = refer_case_title

          let  {class_id} = this.quoteForm||{}
          let language = params.language
          let className = language=='en-US'?this.getOptionName('classOptions', class_id) : this.getOptionName('classChinaOptions', class_id)
          this.emailTitle = this.emailTitle.replace('{{class_language}}', className)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.page-container {
    position: relative;
    padding-bottom: 50px;
    h1 {
      padding-bottom: 10px;
      & + span {
        display: block;
        padding-bottom: 20px;
      }
    }
    h2 {
      padding-top: 15px;
    }
    .title {
      display: block;
      padding-bottom: 15px;
      color: #616266;
      font-size: 20px;
      font-weight: 500;
    }
    & > .table {
        width: calc(100% - 200px);
    }
    .benefits-list {
      span {
        display: block;
      }
    }
}
.width-20{
  width: 150px;
  font-weight: 400;
  padding-bottom: 0px!important;
  margin-left: 10px;
}
.bold {
  font-weight: bold;
  display: flex!important;
  align-items: center;
}
.p-class {
  padding: 10px 0;
  display: flex;
  span {
    display: block;
    padding-bottom: 10px;
    word-break: break-word;
  }
}
</style>
